import React from "react";

// What an admin list, card or panel shows when its read failed (after the
// quiet second try in utils/adminRetry): "Couldn't load {what}." and Retry,
// never the empty state, an all-clear or an endless "Loading…". Same look as
// admin-stats/StatsPending. `inline` is the one-line version for a small
// panel (an expanded row, a card's body).
export default function AdminLoadFailed({
  what,
  onRetry,
  inline = false,
}: {
  what: string;
  onRetry: () => void;
  inline?: boolean;
}) {
  if (inline) {
    return (
      <div className="adm-fs-80" role="alert" style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0" }}>
        <span className="muted-text">Couldn't load {what}.</span>
        <button type="button" className="adm-btn-sm adm-btn-outline" onClick={onRetry}>
          Retry
        </button>
      </div>
    );
  }
  return (
    <div className="adm-center adm-p-30" role="alert">
      <p className="muted-text">Couldn't load {what}.</p>
      <button type="button" className="adm-btn-light" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}
